import { format } from 'date-fns'
import { ja } from 'date-fns/locale/ja'
import { BookingCancelReason } from '@/types/schema.generated'

export const dateStringForDisplay = (booking: {
  startsAt: TimeString
  endsAt: TimeString
}) => {
  const startString = format(
    new Date(booking.startsAt),
    'yyyy年M月d日(E) HH:mm',
    {
      locale: ja,
    }
  )
  const endString = format(new Date(booking.endsAt), 'HH:mm')

  return `${startString} - ${endString}`
}

export const cancelReasonString: Record<BookingCancelReason, string> = {
  [BookingCancelReason.EntranceCancelled]: 'プランナーによってキャンセル済み',
  [BookingCancelReason.UserCancelled]: 'ユーザーによってキャンセル済み',
}
